export default __webpack_public_path__ + "static/2-b212900c8a4f4d06442a4d513f8f5bb0.jpg";